// extracted by mini-css-extract-plugin
export default {"Container":"Terms_Container__w5ay1","Card":"Terms_Card__GK-gM","Title":"Terms_Title__nnqYi","Markdown":"Terms_Markdown__o+mPA"};